import React, { useEffect, useRef, useState, type Dispatch, type SetStateAction } from 'react';

import { Grid, Box } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { SearchButton, SelectCenter, SelectSupplier } from 'components/commonparts'
import SelectDateRange from 'components/commonparts/SelectDateRange/SelectDateRange'

import type { GetMstCalendarCenterSupplierCalendarCenterSupplierGetRequest } from 'hooks/useCenterSupplierCalendar'

interface SearchConditionProps {
  hasDataEdited: boolean
  searchParam: GetMstCalendarCenterSupplierCalendarCenterSupplierGetRequest
  onSearch: (requestParam: GetMstCalendarCenterSupplierCalendarCenterSupplierGetRequest) => void
  setDiscardChangeDialogOpen: Dispatch<SetStateAction<boolean>>,
  searchTrigger?: boolean // 親コンポーネントから検索実行された場合に値が変化する
}

function SearchCondition({
  searchParam, 
  onSearch, 
  hasDataEdited=false,
  setDiscardChangeDialogOpen,
  searchTrigger,
}: SearchConditionProps) {
  const { loginUserInfo } = useAuthContext()

  const [orgCenterId, setOrgCenterId] = useState<string | null | undefined>(searchParam.orgCenterId)
  const [orgSupplierId, setOrgSupplierId] = useState<string | null | undefined>(searchParam.orgSupplierId)
  const [selectDateRange, setSelectDateRange] = useState<string | null | undefined>(searchParam.selectDateRange)

  useEffect(() => {
    setSelectDateRange(searchParam.selectDateRange)
  }, [searchParam.selectDateRange])

  const onSearchClick=()=>{
    if (hasDataEdited) {
      setDiscardChangeDialogOpen((prev) => !prev)
      return
    }

    onSearch({
      companyId: loginUserInfo!.companyId,
      orgCenterId,
      orgSupplierId,
      selectDateRange,
      enabled: false,
    })      
  }

  const isFirstSearchTriggerEffect = useRef(true)
  useEffect(() => {
    // 初回マウントで親の初期 fetch と二重に /calendar-center-supplier が呼ばれるのを防ぐ
    if (isFirstSearchTriggerEffect.current) {
      isFirstSearchTriggerEffect.current = false
      return
    }
    // searchTriggerの変更を検知して、検索イベントを起こす
    // 親コンポーネントなどで検索を行いたい場合は、このトリガーを使用する
    onSearch({
      companyId: loginUserInfo!.companyId,
      orgCenterId,
      orgSupplierId,
      selectDateRange,
      enabled: false,
    })
  }, [searchTrigger])

  return (
    <Grid container>
      <SelectCenter
        trCompanyId={searchParam.companyId}
        orgCenterId={orgCenterId}
        setOrgCenterId={setOrgCenterId}
        setCenterInfo={() => {}}
        isRequired={false}
        setIsValid={() => {}}
        enabled={false}
      />
      <SelectSupplier
        trCompanyId={searchParam.companyId}
        orgSupplierId={orgSupplierId}
        setOrgSupplierId={setOrgSupplierId}
        setSupplierInfo={() => {}}
        isRequred={false}
        setIsValid={() => {}}
        enabled={false}
        alignmentFlag
      />
      <SelectDateRange
        value={selectDateRange ?? null}
        onChange={setSelectDateRange}
      />
      <Box display="flex" justifyContent="center" alignItems="end" marginBottom='5px'>
        <SearchButton searchId="CalendarCenterSupplier" onSearchClick={onSearchClick}/>
      </Box>
    </Grid>
  )
}

export default SearchCondition

